<template>
  <div class="asset-navigator">
    <el-button icon="el-icon-arrow-left" aria-label="上一个资产" :disabled="index <= 0" @click="move(-1)" />
    <el-select :value="value" filterable popper-class="asset-navigator-options last-check" :title="value" @change="$emit('input', $event)">
      <el-option v-for="name in options" :key="name" :label="name" :value="name" />
    </el-select>
    <el-button icon="el-icon-arrow-right" aria-label="下一个资产" :disabled="index < 0 || index >= options.length - 1" @click="move(1)" />
  </div>
</template>
<script>
export default {
  props: { value: String, options: { type: Array, default: () => [] } },
  computed: { index() { return this.options.indexOf(this.value); } },
  methods: { move(step) { const next = this.index + step; if (next >= 0 && next < this.options.length) this.$emit('input', this.options[next]); } },
};
</script>
<style lang="less" scoped>
.asset-navigator {
  display: flex; align-items: center; gap: 8px; width: 100%; min-width: 0; margin-bottom: 12px;
  .el-select { flex: 1; min-width: 0; }
  .el-button { flex: 0 0 32px; margin: 0; padding: 10px 6px; background: var(--Btn-bgc2); color: var(--stock_area_item_color1); border: none; }
  .el-button.is-disabled { opacity: .4; }
  /deep/ .el-input__inner { background: var(--Btn-bgc2); color: var(--stock_area_item_color1); border: none; text-overflow: ellipsis; }
}
</style>
<style>
.asset-navigator-options { max-width: min(640px, 90vw); }
/* 下拉挂在 body 上，拿不到 CSelect 的 scoped 样式；这里按同一套主题变量写，深浅色都跟着走。 */
.asset-navigator-options.el-select-dropdown, .asset-navigator-options.el-popper { background-color: var(--Select-bgc2); border: none; }
.asset-navigator-options .popper__arrow, .asset-navigator-options .popper__arrow::after { border-bottom-color: var(--Select-bgc2) !important; border-top-color: var(--Select-bgc2) !important; }
.asset-navigator-options .el-select-dropdown__item { background-color: var(--Select-bgc2); color: var(--Select-color); }
.asset-navigator-options .el-select-dropdown__item.hover, .asset-navigator-options .el-select-dropdown__item:hover { background-color: var(--Select-bgc); }
.asset-navigator-options .el-select-dropdown__item.selected { color: var(--primary-color, rgb(64, 158, 255)); font-weight: 600; }
.asset-navigator-options .el-select-dropdown__empty { color: var(--Select-color2); }
.asset-navigator-options .el-select-dropdown__item { height: auto; min-height: 34px; white-space: normal; line-height: 1.6; padding-top: 7px; padding-bottom: 7px; }
</style>
